/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, mediaQuery } from '@insticator/insticator-ui'; // iui-utils



// ********* HELPERS ********* //
const questionPropertiesThinStyles = {
	'& .questionformatselector': {
		fontSize: '70%',
		justifyContent: 'space-around',
		alignItems: 'center'
	}
};
const questionPropertiesThinnestStyles = {
	'& .questionformatselector': {
		justifyContent: 'space-around',
		alignItems: 'center'
	}
};



/* ++++++++++ --------------- EXPORT : EMBED QUESTION PROPERTIES : STYLES --------------- ++++++++++ */
export default theme => ({
	questionproperties: {
		'& .questioncontainer': {
			marginBottom: pxToEm(24),
			'& .questionformatselector': {
				display: 'flex',
				flexWrap: 'wrap',
				'& .questionformat':{
					marginBottom: pxToEm(20),
					'&:nth-child(odd)':{
						marginRight: pxToEm(20),
						marginBottom: '0'
					},
					'&:last-child': {
						marginBottom: pxToEm(0)
					}
				}
			}
		},
	},

	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
	[mediaQuery.customizeThinnest]: {
		questionproperties: {
			extend: questionPropertiesThinnestStyles
		}
	},
	[mediaQuery.customizeRailThin]: {
		questionproperties: {
			'&.rail': { extend: questionPropertiesThinStyles }
		}
	},
	[mediaQuery.customizeInContentThin]: {
		questionproperties: {
			'&.incontent': { extend: questionPropertiesThinStyles }
		}
	}
});
